// ─────────────────────────────────────────────────────────────────────────────
// MapToolbar — the row above the map: the Active Connections readout on the
// left, then Add Node and the zoom stepper on the right. Purely presentational;
// the value, the zoom state and the add handler are all owned above.
// ─────────────────────────────────────────────────────────────────────────────
import styles from "./NodeMap.module.css";
import { Icons } from "../../../../components/Icons";
import { ZoomInIcon, ZoomOutIcon } from "./icons";
import { ZOOM_LEVELS } from "./useZoom";
import AddNodeButton from "../AddNodeButton";
import { fmtCount } from "../../format";

export default function MapToolbar({ activeConnections, zoom, onAddNode, canWrite = false }) {
  return (
    <div className={styles.topBar}>
      <div className={styles.connChip}>
        <span className={styles.connIcon}>{Icons.users}</span>
        <span className={styles.connLabel}>Active Connections</span>
        <span className={styles.connValue}>{fmtCount(activeConnections)}</span>
      </div>

      <div className={styles.actions}>
        {/* Creating a node needs read_write on node_monitoring — hidden, not
            disabled, for a viewer who could never use it. */}
        {canWrite && <AddNodeButton onClick={onAddNode} />}

        <div className={styles.zoom}>
          <button
            className={styles.zoomBtn}
            onClick={zoom.zoomOut}
            disabled={!zoom.canZoomOut}
            aria-label="Zoom out"
          >
            <ZoomOutIcon />
          </button>

          {/* one bar per zoom level, the current one lit */}
          <div className={styles.zoomBars}>
            {ZOOM_LEVELS.map((level, i) => (
              <span
                key={level}
                className={`${styles.zoomBar} ${i === zoom.index ? styles.zoomBarOn : ""}`}
              />
            ))}
          </div>

          <button
            className={styles.zoomBtn}
            onClick={zoom.zoomIn}
            disabled={!zoom.canZoomIn}
            aria-label="Zoom in"
          >
            <ZoomInIcon />
          </button>
        </div>
      </div>
    </div>
  );
}
